import React, { PureComponent } from 'react'

export default class EmbeddedDashboards extends PureComponent {
    render() {
        return <div className="dashboards">{this.props.children}</div>
    }
}
